import { createFileRoute, Navigate } from "@tanstack/react-router";
import type { JSX } from "react";
import WorkspaceOnboardingPage, { type OnboardingStep } from "@/components/onboarding/workspace-onboarding-page";
import SpinnerPage from "@/components/pages/spinner-page";
import { workspaceNeedsOnboarding } from "@/lib/workspace/onboarding";
import { useCurrentUser } from "@/queries/user/useCurrentUser.query";

const parseStep = (value: unknown): OnboardingStep => (value === "mode" || value === "team" ? value : "name");

const OnboardingRoute = (): JSX.Element => {
	const { user, isInitialLoading } = useCurrentUser();
	const { step } = Route.useSearch();
	const navigate = Route.useNavigate();

	if (isInitialLoading) {
		return <SpinnerPage />;
	}

	if (!workspaceNeedsOnboarding(user)) {
		return <Navigate to="/timer" />;
	}

	return (
		<WorkspaceOnboardingPage
			onStepChange={(next) => {
				void navigate({ search: { step: next } });
			}}
			step={step}
		/>
	);
};

export const Route = createFileRoute("/_app/onboarding/")({
	component: OnboardingRoute,
	validateSearch: (search: Record<string, unknown>): { readonly step: OnboardingStep } => ({
		step: parseStep(search.step),
	}),
});
